import axios, { AxiosInstance, AxiosResponse } from "axios";
import config from "@/utils/cognitoUrlConfig";

interface Distribution {
  type: string
  url: string
}

interface Cookie {
  name: string
  value: string
}


interface CookieResponse {
  distributions: Array<Distribution>
  cookie: Array<Cookie>
}

class CookieService {
  client: AxiosInstance;

  constructor(jwt: string) {
    this.client = axios.create({
      baseURL: config.apiURL,
      withCredentials: true, //for test get cookie on localhost turn it false
      headers: {
        Authorization: jwt
      }
    });
  }
  async getCookie(): Promise<AxiosResponse<CookieResponse>> {
    return await this.client.get("/cookie");
  }
}

export default CookieService;
